import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITabsState } from '../../types/tabs';

export enum ETabsActionTypes {
  UpdateTabs = 'TABS/UPDATE',
}

export type TUpdateTabs = ITypedReduxAction<ETabsActionTypes.UpdateTabs, ITabsState>;

export const updateTabs: (tabs: ITabsState) => TUpdateTabs = actionGenerator<ETabsActionTypes.UpdateTabs, ITabsState>(
  ETabsActionTypes.UpdateTabs,
);
